import React from 'react';
import { theme } from '../theme';

const LoadingSpinner = ({ size = 'sm', text = 'Loading...' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
  };

  return (
    <div className="flex items-center space-x-2">
      <div 
        className={`${sizeClasses[size]} border-2 border-t-transparent rounded-full animate-spin`}
        style={{ 
          borderColor: theme.colors.accent.blue,
          borderTopColor: 'transparent'
        }}
      />
      {text && (
        <span 
          className="text-sm"
          style={{ color: theme.colors.text.secondary }}
        >
          {text}
        </span>
      )}
    </div>
  );
};

export default LoadingSpinner;
